export function isFatalErrorWithCode(
    error: any
): error is { type: "fatal_error"; reason: { code: string } } {
    if (typeof error === "object" && error !== null) {
        if ("reason" in error && "type" in error) {
            const { type, reason } = error;
            if (type === "fatal_error" && typeof reason === "object" && reason !== null) {
                return "code" in reason;
            }
        }
    }
    return false;
}
